import { useTranslation } from 'react-i18next';

import denisTImg from '@/assets/whoWeAre_team_denisT.png';
import patrykBImg from '@/assets/whoWeAre_team_patrykB.png';

export const teamMembers = [
  {
    name: 'Denis T.',
    position: 'positionDeveloperAndFounder',
    avatar: denisTImg,
    backgroundColor: '#607C91',
  },
  {
    name: 'Patryk B.',
    position: 'positionDeveloperAndFounder',
    avatar: patrykBImg,
    backgroundColor: '#D7DFE9',
  },
];

export const OurTeamSection = () => {
  const { t } = useTranslation('whoWeAre');

  return (
    <div className="section bg-background1">
      <div className="flex justify-center items-center text-3xl md:text-4xl font-bold">
        <h1 className="section-title flex justify-self-center">{t('ourTeam')}</h1>
      </div>

      <div className="flex justify-center mt-8">
        <div className="grid sm:grid-cols-2 gap-5 2xl:gap-10 flex mt-10 w-full max-w-[1000px]">
          {teamMembers.map((member, index) => (
            <div key={index}>
              <div className="flex justify-center bg-white rounded-xl p-8">
                <div>
                  <div className="flex justify-center">
                    <div
                      className="flex justify-center items-center rounded-full w-40 h-40 overflow-hidden"
                      style={{ backgroundColor: member.backgroundColor }}
                    >
                      <img
                        src={member.avatar}
                        alt={member.position}
                        className="w-40 h-40"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="text-center my-4">
                    <h1 className="font-semibold text-xl">{member.name}</h1>
                    <p className="font-semibold text-sm text-button uppercase">
                      {t(member.position)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
